"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CarvanaThemeDeprecated = void 0;

var react_1 = __importStar(require("react"));

var styled_components_1 = require("styled-components");

var loadingTheme_1 = __importDefault(require("./loadingTheme"));

var CarvanaTheme_1 = __importDefault(require("./CarvanaTheme"));

var themeMap_1 = __importDefault(require("../themeMap"));

exports.CarvanaThemeDeprecated = __assign(__assign({}, CarvanaTheme_1.default), {
  carvana: {
    // 2.0 palette -- https://carvana.invisionapp.com/share/8CH6ZTCX5ER#/screens
    body: '#e4ecf0',
    blue: {
      primary: '#00aed9',
      hover: '#018dc0',
      medium: '#00619e',
      dark: '#183558',
      pastel: '#cfeaf2' // accent

    },
    gray: {
      background: '#f4f8fa',
      light: '#d9dde9',
      medium: '#aab1c7',
      dark: '#757989' // text and icons

    },
    green: {
      primary: '#1dd08b' // success green

    },
    red: {
      primary: '#ff7171' // alert red, faved

    },
    yellow: {
      primary: '#feb948',
      hover: '#eb9f23',
      pastel: '#fbf2de' // accent

    },
    white: {
      primary: '#ffffff'
    },
    stroke: {
      blue: '#122946' // divider line color in header and footer

    },
    impersonationRed: '#ff0000'
  },
  typography: {
    fontFamily: "'Brandon Text', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'" + ''
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 768,
      md: 1024,
      lg: 1280,
      xl: 1920
    }
  }
});

var ThemeProvider =
/** @class */
function (_super) {
  __extends(ThemeProvider, _super);

  function ThemeProvider(props) {
    var _this = _super.call(this, props) || this;

    _this.state = {
      allowLoading: props.swappable,
      baseTheme: props.theme
    };
    return _this;
  }

  ThemeProvider.prototype.componentDidUpdate = function (prevProps) {
    var _a = this.props,
        swappable = _a.swappable,
        theme = _a.theme;

    if (prevProps.theme !== theme && swappable) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({
        allowLoading: false
      });
    }
  };

  ThemeProvider.prototype.render = function () {
    var _a = this.state,
        allowLoading = _a.allowLoading,
        baseTheme = _a.baseTheme;
    var _b = this.props,
        theme = _b.theme,
        children = _b.children,
        swappable = _b.swappable;
    var useTheme = allowLoading && swappable ? loadingTheme_1.default : theme;

    var themeWithOld = __assign(__assign({}, baseTheme), useTheme);

    var replaceOldValue = function replaceOldValue(primary, secondary) {
      if (secondary === void 0) {
        secondary = '';
      }

      var selector = secondary ? "carvana." + primary + "." + secondary : "carvana." + primary;

      if (themeMap_1.default[selector]) {
        var newValue = themeMap_1.default[selector].split('.').reduce(function (o, i) {
          return o[i];
        }, themeWithOld);

        if (secondary) {
          themeWithOld.carvana[primary][secondary] = newValue;
        } else {
          themeWithOld.carvana[primary] = newValue;
        }
      }
    };

    if (themeWithOld.carvana) {
      Object.keys(themeWithOld.carvana).forEach(function (color) {
        var val = themeWithOld.carvana[color];

        if (typeof val === 'string') {
          replaceOldValue(color);
        } else {
          Object.keys(val).forEach(function (colorType) {
            replaceOldValue(color, colorType);
          });
        }
      });
    }

    return react_1.default.createElement(styled_components_1.ThemeProvider, {
      theme: themeWithOld
    }, react_1.default.createElement(react_1.default.Fragment, null, children));
  };

  ThemeProvider.defaultProps = {
    theme: CarvanaTheme_1.default,
    swappable: false
  };
  return ThemeProvider;
}(react_1.PureComponent);

exports.default = ThemeProvider;